import { Alert, AlertDescription } from '@/components/ui/alert';

export function FormError({ error }: { error: string }) {
  if (!error) {
    return null;
  }

  return (
    <Alert variant="destructive">
      <AlertDescription>{error}</AlertDescription>
    </Alert>
  );
}
